import { css } from 'lit';

export default css`
  /* Colors */
  --color-primary: #001D68;
  --color-primary-light: #193377;
  --color-primary-dark: #00144A;
  --color-secondary: #2594E3;
  --color-secondary-light: #46A4E7;
  --color-secondary-light-1: #c3d6e3;
  --color-secondary-light-2: #46d2e7;
  --color-secondary-light-3: #eff2f6;
  --color-secondary-dark: #1D76B5;
  --color-red: #D1232A;
  --color-red-light: #FF2B32;
  --color-red-dark: #951C21;
  --color-yellow: #FFEC19;
  --color-yellow-light: #FFF15E;
  --color-yellow-dark: #E5D416;
  --color-green: #72B509;
  --color-green-light: #8EC33A;
  --color-green-light-1: #e8eede;
  --color-green-dark: #66A208;
  --color-purple: #33109C;
  --color-purple-light: #4727A5;
  --color-purple-dark: #280C7C;
  --color-orange: #FF9505;
  --color-orange-light: #FFA21F;
  --color-orange-dark: #F58F00;

  /* Gray Scale */
  --color-white: #FFFFFF;
  --color-black: #030711;
  --color-gray-1: #F7F5F4;
  --color-gray-2: #E7E5E4;
  --color-gray-3: #D7D4D2;
  --color-gray-4: #7C7C7C;
  --color-gray-5: #6C6C6C;
  --color-gray-6: #565454;
  --color-gray-7: #424242;
  --color-gray-8: #263238;
  --color-gray-9: #1C2321;

  /* New colors from input */
  --color-success: #72B509;
  --color-warning: #FF9505;
  --color-warning-light: #FEF3C7;
  --color-error: #FF2B32;
  --color-dark-gray: #1C2321;

  /* Prism Highlights */
  --color-prism-red-dark: #f02917;
  --color-prism-red-normal: #d62216;
  --color-prism-red-light: #e7d9d9;
  --color-prism-red-light-1: #e47373;
  --color-prism-orange-dark: #CC5500;
  --color-prism-orange-normal: #FF8C00;
  --color-prism-orange-light: #FFB266;
  --color-prism-yellow-dark: #997700;
  --color-prism-yellow-normal: #CCCC00;
  --color-prism-yellow-light: #E6E600;
  --color-prism-green-dark: #0b630b;
  --color-prism-green-normal: #149a14;
  --color-prism-green-light: #59dd59;
  --color-prism-blue-dark: #00008B;
  --color-prism-blue-normal: #0909cf;
  --color-prism-blue-light: #6666FF;
  --color-prism-indigo-dark: #2F0047;
  --color-prism-indigo-normal: #4B0082;
  --color-prism-indigo-light: #7A4DB2;
  --color-prism-violet-dark: #4B0082;
  --color-prism-violet-normal: #EE82EE;
  --color-prism-violet-light: #F5A9F2;

  /* App Highlights */

  --color-app-author: var(--color-secondary);
  --color-app-dam: var(--color-prism-indigo-normal);
  --color-app-publisher: var(--color-prism-red-normal);
  --color-app-keyword: var(--color-prism-blue-dark);
  --color-app-search-console: var(--color-secondary);
  --color-app-lothar: var(--color-prism-orange-normal);
  --color-app-update-asset: var(--color-prism-green-normal); /* Magic Assets: 3.7:1 on white, 5:1 on dark base */

  /* Text */
  --base-text-color: var(--color-gray-9);
`;